// import React from "react";

// const sizeStyles = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const sizeValueStyles = {
//   sm: "text-[14px]",
//   md: "text-[16px]",
//   lg: "text-[18px]",
//   xl: "text-[20px]",
// };

// const iconSizeStyles = {
//   sm: "text-[18px]",
//   md: "text-[20px]",
//   lg: "text-[24px]",
//   xl: "text-[28px]",
// };

// const InfoText = ({
//   title,
//   icon = "info",
//   value,
//   size = "md", //sm,md,lg,xl
// }) => {
//   return (
//     <div
//       className={`flex ${
//         title ? "text-neutrals flex-col gap-2" : "flex-row items-center gap-2  "
//       }`}
//     >
//       {title ? (
//         <div className={`leading-none text-nowrap ${sizeStyles[size]}`}>
//           {title}
//         </div>
//       ) : (
//         <span
//           className={`material-symbols-rounded font-extralight  ${iconSizeStyles[size]}`}
//         >
//           {icon}
//         </span>
//       )}
//       <div
//         // className={`text-black  leading-none text-nowrap  ${sizeValueStyles[size]}`}
//         className={`text-black  leading-none text-balance  ${sizeValueStyles[size]}`}
//       >
//         {!value && value === "" ? "-" : value}
//       </div>
//     </div>
//   );
// };

// export default InfoText;

// import React from "react";

// const sizeStyles = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const sizeValueStyles = {
//   sm: "text-[14px]",
//   md: "text-[16px]",
//   lg: "text-[18px]",
//   xl: "text-[20px]",
// };

// const iconSizeStyles = {
//   sm: "text-[18px]",
//   md: "text-[20px]",
//   lg: "text-[24px]",
//   xl: "text-[28px]",
// };

// const InfoText = ({
//   title,
//   icon = "info",
//   value,
//   size = "md", // sm, md, lg, xl
//   prefix = null,
//   suffix = null,
//   statusTag = null,
// }) => {
//   const renderValue = () => {
//     if (!value && value !== 0) return "-";

//     if (Array.isArray(value)) {
//       return value.map((v, i) => (
//         <span key={i} className="inline-block mr-1 last:mr-0">
//           {v}
//         </span>
//       ));
//     }

//     return value;
//   };

//   return (
//     <div
//       className={`flex ${
//         title ? "text-neutrals flex-col gap-2" : "flex-row items-center gap-2"
//       }`}
//     >
//       {title ? (
//         <div className={`leading-none text-nowrap ${sizeStyles[size]}`}>
//           {title}
//         </div>
//       ) : (
//         <span
//           className={`material-symbols-rounded font-extralight ${iconSizeStyles[size]}`}
//         >
//           {icon}
//         </span>
//       )}

//       <div
//         className={`text-black leading-none text-balance flex items-center gap-1 flex-nowrap ${sizeValueStyles[size]}`}
//       >
//         {prefix && <div>{prefix}</div>}
//         {renderValue()}
//         {suffix && <div>{suffix}</div>}
//         {statusTag && (
//           <span className="ml-2 px-2 py-0.5 rounded-full bg-gray-200 text-gray-800 text-xs">
//             {statusTag}
//           </span>
//         )}
//       </div>
//     </div>
//   );
// };

// export default InfoText;

//these is working but small changes
// import React from "react";

// const sizeStyles = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const sizeValueStyles = {
//   sm: "text-[14px]",
//   md: "text-[16px]",
//   lg: "text-[18px]",
//   xl: "text-[20px]",
// };

// const iconSizeStyles = {
//   sm: "text-[18px]",
//   md: "text-[20px]",
//   lg: "text-[24px]",
//   xl: "text-[28px]",
// };

// const InfoText = ({
//   title,
//   icon = "info",
//   value,
//   size = "md", // sm, md, lg, xl
// }) => {
//   const valueItems = Array.isArray(value) ? value : [value];

//   return (
//     <div
//       className={`flex ${
//         title ? "flex-col gap-2 text-neutrals" : "flex-row items-center gap-2"
//       }`}
//     >
//       {title ? (
//         <div className={`leading-none text-nowrap ${sizeStyles[size]}`}>
//           {title}
//         </div>
//       ) : (
//         <span
//           className={`material-symbols-rounded font-extralight ${iconSizeStyles[size]}`}
//         >
//           {icon}
//         </span>
//       )}

//       {valueItems.map((item, index) => (
//         <div
//           key={index}
//           className={`flex  items-start flex-wrap gap-2 ${sizeValueStyles[size]} text-black`}
//         >
//           <div className="flex-1 min-w-0 flex items-center  gap-1">
//             {/* optional we can pass before value */}
//             {item.prefix && <div>{item.prefix}</div>}
//             {/* <div className="break-words">{item.value || "-"}</div> */}
//             {typeof item.value === "object" &&
//             item.value.label &&
//             item.value.href ? (
//               <a
//                 href={item.value.href}
//                 download
//                 target="_blank"

//                 className="break-words"
//               >
//                 {item.value.label}
//               </a>
//             ) : (
//               <div className="break-words">{item.value || "-"}</div>
//             )}

//             {item.suffix && <div>{item.suffix}</div>}
//             {item.statusTag && <span>{item.statusTag}</span>}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoText;

//third
// import React from "react";

// const sizeStyles = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const sizeValueStyles = {
//   sm: "text-[14px]",
//   md: "text-[16px]",
//   lg: "text-[18px]",
//   xl: "text-[20px]",
// };

// const iconSizeStyles = {
//   sm: "text-[18px]",
//   md: "text-[20px]",
//   lg: "text-[24px]",
//   xl: "text-[28px]",
// };

// const InfoText = ({
//   title,
//   icon = "info",
//   value,
//   size = "md", // sm, md, lg, xl
// }) => {
//   const valueItems = Array.isArray(value) ? value : [value];

//   return (
//     <div
//       className={`flex ${
//         title ? "flex-col gap-2 text-neutrals" : "flex-row items-center gap-2"
//       }`}
//     >
//       {title ? (
//         <div className={`leading-none text-nowrap ${sizeStyles[size]}`}>
//           {title}
//         </div>
//       ) : (
//         <span
//           className={`material-symbols-rounded font-extralight ${iconSizeStyles[size]}`}
//         >
//           {icon}
//         </span>
//       )}

//       {valueItems.map((item, index) => (
//         <div
//           key={index}
//           className={`flex items-start flex-wrap gap-2 ${sizeValueStyles[size]} text-black`}
//         >
//           <div className="flex-1  flex items-center text-balance gap-1 ">
//             {React.isValidElement(item.value) ? (
//               item.value
//             ) : typeof item.value === "object" &&
//               item.value.label &&
//               item.value.href ? (
//               <a
//                 href={item.value.href}
//                 download
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="break-words"
//               >
//                 {item.value.label}
//               </a>
//             ) : (
//               <div>{item.value || "-"}</div>
//             )}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoText;

// import React from "react";

// const sizeStyles = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const sizeValueStyles = {
//   sm: "text-[14px]",
//   md: "text-[16px]",
//   lg: "text-[18px]",
//   xl: "text-[20px]",
// };

// const iconSizeStyles = {
//   sm: "text-[18px]",
//   md: "text-[20px]",
//   lg: "text-[24px]",
//   xl: "text-[28px]",
// };

// const InfoText = ({
//   title,
//   icon = "info",
//   value,
//   size = "md", // sm, md, lg, xl
// }) => {
//   const valueItems = Array.isArray(value) ? value : [value];

//   return (
//     <div
//       className={`flex ${
//         title ? "flex-col gap-2 text-neutrals" : "flex-row items-center gap-2"
//       }`}
//     >
//       {title ? (
//         <div className={`leading-none text-nowrap ${sizeStyles[size]}`}>
//           {title}
//         </div>
//       ) : (
//         <span
//           className={`material-symbols-rounded font-extralight ${iconSizeStyles[size]}`}
//         >
//           {icon}
//         </span>
//       )}

//       {valueItems.map((item, index) => (
//         <div
//           key={index}
//           className={`flex items-start flex-wrap gap-2 ${sizeValueStyles[size]} text-black`}
//         >
//           <div className="flex-1 min-w-0 flex items-center gap-1">
//             {/* optional we can pass before value */}
//             {item.before && <div>{item.before}</div>}

//             {typeof item.value === "object" &&
//             item.value.label &&
//             item.value.href ? (
//               <a
//                 href={item.value.href}
//                 download
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="break-words"
//               >
//                 {item.value.label}
//               </a>
//             ) : (
//               <div className="break-words">{item.value || "-"}</div>
//             )}

//             {item.after && <div>{item.after}</div>}
//             {item.statusTag && <span>{item.statusTag}</span>}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InfoText;

import React from "react";

const sizeStyles = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const sizeValueStyles = {
  sm: "text-[14px]",
  md: "text-[16px]",
  lg: "text-[18px]",
  xl: "text-[20px]",
};

const iconSizeStyles = {
  sm: "text-[18px]",
  md: "text-[20px]",
  lg: "text-[24px]",
  xl: "text-[28px]",
};

const InfoText = ({
  title,
  icon = "info",
  value,
  size = "md", // sm, md, lg, xl
}) => {
  const valueItems = Array.isArray(value) ? value : [value];

  return (
    <div
      className={`flex ${
        title ? "flex-col gap-2 text-neutrals" : "flex-row items-center gap-2"
      }`}
    >
      {title ? (
        <div className={`leading-none text-nowrap ${sizeStyles[size]}`}>
          {title}
        </div>
      ) : (
        <span
          className={`material-symbols-rounded font-extralight ${iconSizeStyles[size]}`}
        >
          {icon}
        </span>
      )}

      {valueItems.map((item, index) => (
        <div
          key={index}
          className={`flex items-start flex-wrap gap-2 ${sizeValueStyles[size]} text-black`}
        >
          <div className="flex-1 min-w-0 flex items-center gap-1 flex-wrap">
            {item.before && <div>{item.before}</div>}
            {typeof item.value === "object" &&
            item.value?.label &&
            item.value?.href ? (
              <a
                href={item.value.href}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="break-words"
              >
                {item.value.label}
              </a>
            ) : (
              <div className="break-words">{item.value || "-"}</div>
            )}

            {item.after && (
              <div className="flex items-center gap-1 flex-wrap">
                {item.after}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfoText;
